import { createReducer } from "reduxsauce";
import ReducerRegister from "../../../ReducerRegister";
import ListService from "../../../../services/screens/admin/messageboard/ListService";
import { ActionTypes } from "../../../actionTypes/screens/admin/messageboard/ListActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import _ from "lodash";
import UIDs from "../../../../UIDs";
import Constants from "../../../../config/Constants";
const uid = UIDs.screens.admin.messageboard.list;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: searchVO => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, searchVO });

            ListService.loadScreenView(
                searchVO,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, searchVO));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, searchVO) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        searchVO
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    updateFilterBy: filter => ({
        type: ActionTypes.UPDATE_FILTER_BY,
        filter
    }),

    deleteAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.DELETE_ASYNC, vo });

            ListService.delete(
                vo,
                response => {
                    dispatch(Actions.deleteSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.deleteFailure(error));
                }
            );
        };
    },

    deleteSuccess: (data, vo) => ({
        type: ActionTypes.DELETE_SUCCESS,
        parentType: ActionTypes.DELETE_ASYNC,
        postReducer: deleteSuccessPostReducer,
        data,
        vo
    }),

    deleteFailure: error => ({
        type: ActionTypes.DELETE_FAILURE,
        parentType: ActionTypes.DELETE_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    messageBoardList: null,
    totalCount: 0,
    pageCount: 0,
    toBeViewedCount: 0,
    searchVO: {
        pageIndex: 1,
        pageSize: Constants.DefaultPageSize,
        name: "",
    },
    filter: ""
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, searchVO }) => {
    const { messageBoardList, totalCount, pageCount, toBeViewedCount } = data.pagedMessageBoard;
    return { ...state, messageBoardList, totalCount, pageCount, toBeViewedCount, searchVO };
};

const updateFilterByReducer = (state, { filter }) => {
    return { 
        ...state,
        filter, 
        searchVO: {
            pageIndex: 1,
            pageSize: Constants.DefaultPageSize,
            name: "",
        }
    };
};

const deleteSuccessPostReducer = (state, { vo }) => {
    const { messageBoardList } = state;
    let newMessageBoardList = _.clone(messageBoardList);
    let index = newMessageBoardList.length - 1;
    while (index >= 0) {
        if (newMessageBoardList[index].id === vo.id)
        newMessageBoardList.splice(index, 1);
        index -= 1;
    }
    let newTotalCount = state.totalCount - 1;
    return { ...state, messageBoardList: newMessageBoardList, totalCount: newTotalCount };
};
// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_FILTER_BY]: updateFilterByReducer,
    [ActionTypes.DELETE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.DELETE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.DELETE_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
